export const TTC2HT = (ttc, tax) => {
  return Number.parseFloat(
    Number.parseFloat(ttc / (1 + tax / 100.0)).toFixed(2)
  );
};
